/**
 * The Premium Lite note above the journey list (client, 20–21/10/2026).
 *
 * During the 72 hours after a new Premium Lite starts the member may switch
 * journeys freely; the one active at the end becomes the journey included in
 * their Premium Lite. After that the note just names it.
 *
 * `premiumLite` is the page-header block; `mainName` is the name of the list
 * card marked `premium_lite_role: "main"` (fresher than the header after a
 * choice), falling back to the header's.
 */
/** The window opened because a non-continuous journey ended (client, 27/10/2026). */
export const JOURNEY_COMPLETED = "journey_completed";

// «Metabolico (standard)» is the CRM's name: the member reads «Metabolico».
export const cleanJourneyName = (name) =>
  String(name || "")
    .replace(/\s*\(standard\)\s*$/i, "")
    .trim();

/** The journey just completed, while its 72-hour window is open; else null. */
export const completedJourneyName = (premiumLite) =>
  premiumLite?.window_open && premiumLite?.window_reason === JOURNEY_COMPLETED
    ? cleanJourneyName(premiumLite.completed_protocol_name) || "il tuo percorso"
    : null;

export function formatWindowEnd(iso) {
  if (!iso) return null;

  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return null;

  const day = new Intl.DateTimeFormat("it-IT", {
    weekday: "long",
    day: "numeric",
    month: "long",
    timeZone: "Europe/Rome",
  }).format(date);
  const time = new Intl.DateTimeFormat("it-IT", {
    hour: "2-digit",
    minute: "2-digit",
    timeZone: "Europe/Rome",
  }).format(date);

  return `${day} alle ${time}`;
}

export function premiumLiteJourneyBanner(premiumLite, mainName = null) {
  if (!premiumLite) return null;

  const name = mainName || premiumLite.main_protocol_name || null;
  const until = premiumLite.window_open ? formatWindowEnd(premiumLite.window_ends_at) : null;

  // A Speciale / Stagionale journey ended (client, 27/10/2026).
  const completed = until ? completedJourneyName(premiumLite) : null;
  if (completed) {
    return {
      open: true,
      title: `Hai completato ${completed}`,
      body: `Ora scegli il percorso con cui continuare. Puoi cambiare percorso fino a ${until}. Al termine, il percorso attivo diventerà quello incluso nel tuo Premium Lite.`,
      current: name ? `Percorso attivo: ${name}` : null,
    };
  }

  if (until) {
    return {
      open: true,
      title: "Scegli il tuo percorso",
      body: `Puoi cambiare percorso fino a ${until}. Al termine, il percorso attivo diventerà quello incluso nel tuo Premium Lite.`,
      current: name ? `Percorso attivo: ${name}` : null,
    };
  }

  if (!name) return null;

  return {
    open: false,
    title: `Il tuo percorso Premium Lite: ${name}`,
    body: "Con Premium puoi accedere a tutti i percorsi nutrizionali e passare da uno all’altro quando vuoi.",
    current: null,
  };
}
